/* global reportViewChromeModuleName reportViewChromeLandingUrl reportViewChromeGalleryUrl */
/* global reportViewChromeModuleSwitcher reportViewChromeReports */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

/**
 * Report-view chrome (IB-672).
 *
 * The compact top bar on a full-page report view: a breadcrumb back to the
 * landing and gallery, a "Reports" quick-switch dropdown (this group's templates
 * + the user's saved reports), and the module switcher across builder-backed
 * groups. Mounts into #ReportViewChrome above the builder. Module-agnostic —
 * RADIO (IB-679) reuses it unchanged.
 */
const ReportViewChrome = ({ moduleName, landingUrl, galleryUrl, moduleSwitcher, reports }) => {
    const switcherModules = moduleSwitcher || [];
    const quickSwitch = reports || [];

    const navigate = (url) => {
        if (url) {
            window.location.href = url;
        }
    };

    return (
        <div className="tw-flex tw-flex-col md:tw-flex-row md:tw-items-center md:tw-justify-between tw-gap-3 tw-mb-4">
            <nav aria-label={$t('Breadcrumb')} className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-charcoal-75">
                <a href={landingUrl} className="tw-text-blue hover:tw-underline">
                    {$t('Report Centre')}
                </a>
                <span aria-hidden="true">&rsaquo;</span>
                <a href={galleryUrl} className="tw-text-blue hover:tw-underline">
                    {$t(moduleName)}
                </a>
            </nav>

            <div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-gap-2">
                {quickSwitch.length > 0 ? (
                    <select
                        className="tw-rounded-lg tw-border tw-border-grey tw-px-3 tw-py-2 tw-text-sm"
                        aria-label={$t('Switch report')}
                        value=""
                        onChange={(e) => navigate(e.target.value)}
                    >
                        <option value="" disabled>
                            {$t('Switch report…')}
                        </option>
                        {quickSwitch.map((report, index) => (
                            // Names are a mix of template labels (pre-translated server-side)
                            // and user-entered saved-report names; both render raw here rather
                            // than through the translator (i18next would interpolate {{ }}
                            // tokens in user input).
                            <option key={`${report.url}-${index}`} value={report.url}>
                                {report.name}
                            </option>
                        ))}
                    </select>
                ) : null}

                {switcherModules.length > 0 ? (
                    <nav className="tw-flex tw-items-center tw-gap-2" aria-label={$t('Report groups')}>
                        {switcherModules.map((module) => {
                            const isActive = module.url === galleryUrl;

                            return (
                                <a
                                    key={module.key}
                                    href={module.url}
                                    aria-current={isActive ? 'page' : undefined}
                                    className={[
                                        'tw-px-3 tw-py-1.5 tw-rounded-full tw-text-sm tw-font-medium tw-transition-colors',
                                        isActive ? 'tw-bg-blue tw-text-white' : 'tw-bg-white tw-text-charcoal tw-border tw-border-grey hover:tw-border-blue',
                                    ].join(' ')}
                                >
                                    {$t(module.name)}
                                </a>
                            );
                        })}
                    </nav>
                ) : null}
            </div>
        </div>
    );
};

export default ReportViewChrome;

const rootEl = document.getElementById('ReportViewChrome');

if (rootEl) {
    ReactDOM.render(
        <App>
            <ReportViewChrome
                moduleName={typeof reportViewChromeModuleName !== 'undefined' ? reportViewChromeModuleName : ''}
                landingUrl={typeof reportViewChromeLandingUrl !== 'undefined' ? reportViewChromeLandingUrl : ''}
                galleryUrl={typeof reportViewChromeGalleryUrl !== 'undefined' ? reportViewChromeGalleryUrl : ''}
                moduleSwitcher={typeof reportViewChromeModuleSwitcher !== 'undefined' ? reportViewChromeModuleSwitcher : []}
                reports={typeof reportViewChromeReports !== 'undefined' ? reportViewChromeReports : []}
            />
        </App>,
        rootEl,
    );
}
